import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { content } from '../data/content';
import logo from "../assets/logo-foody.PNG";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-neutral-900/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <button
            onClick={() => scrollToSection('hero')}
            className="flex items-center group"
          >
            <img 
              src={logo}
              alt="Foody Burger 49"
              className="h-12 w-auto transition-transform duration-200 group-hover:scale-105"
            />
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('about')}
              className="text-amber-50/80 hover:text-amber-50 transition-colors duration-200 font-medium"
            >
              Storia
            </button>
            <button
              onClick={() => scrollToSection('why-choose')}
              className="text-amber-50/80 hover:text-amber-50 transition-colors duration-200 font-medium"
            >
              Per i Brand
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-amber-50/80 hover:text-amber-50 transition-colors duration-200 font-medium"
            >
              Servizi
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className="text-amber-50/80 hover:text-amber-50 transition-colors duration-200 font-medium"
            >
              Gallery
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-red-600 hover:bg-red-700 text-white px-6 py-2.5 rounded-lg font-semibold transition-all duration-200 shadow-lg hover:shadow-red-600/50 hover:scale-105"
            >
              Contatti
            </button>
            <a
              href={`tel:${content.contact.phone}`}
              className="text-amber-50/80 hover:text-amber-50 transition-colors duration-200"
            >
              <Phone className="w-5 h-5" />
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-amber-50 p-2"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden py-4 border-t border-amber-50/10">
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('about')}
                className="text-amber-50/80 hover:text-amber-50 transition-colors duration-200 font-medium text-left"
              >
                Storia
              </button>
              <button
                onClick={() => scrollToSection('why-choose')}
                className="text-amber-50/80 hover:text-amber-50 transition-colors duration-200 font-medium text-left"
              >
                Per i Brand
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="text-amber-50/80 hover:text-amber-50 transition-colors duration-200 font-medium text-left"
              >
                Servizi
              </button>
              <button
                onClick={() => scrollToSection('gallery')}
                className="text-amber-50/80 hover:text-amber-50 transition-colors duration-200 font-medium text-left"
              >
                Gallery
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="bg-red-600 hover:bg-red-700 text-white px-6 py-2.5 rounded-lg font-semibold transition-all duration-200 shadow-lg text-left"
              >
                Contatti
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
